import type { FaireProductEntity } from "../../entity_types/product";

export const p_fsmv6fetud: FaireProductEntity = {
  token: "p_fsmv6fetud",
  type: "product",
  name: "You're My Favorite Bitch to Bitch About Bitches With Candle",
  brandToken: "b_ez24ksxptb",
  brandName: "Cedar Crate Market",
  imageUrl:
    "https://cdn.faire.com/fastly/64c84971e8ae60fe3eed86f2a0effd0e271ef933911f0f96899b33e2580d7fe0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ecb56c467cc0d092aa6e854af34e6fb758189e9a1de8a25f5abb711548c42943.jpeg",
    "https://cdn.faire.com/fastly/4378c33f74bfd6f8e797456580294b9d162fa182a5d9937c10cfafaafce6a6d4.jpeg",
    "https://cdn.faire.com/fastly/7ab79fbf830270bf0e954d235b7c5e997242379e1b0c78a1ee7ff5d3603bbc9f.jpeg",
  ],
  priceDollars: 12,
  description:
    "You're My Favorite Bitch to Bitch About Bitches With Candle\n\nSCENT: #11 Lemon + Peach Orange. Fresh apples and oranges are combined with green, jasmine, rose, and musk for a delightful scent. \n NOTES: Top: Apple, Orange, Green Middle: Jasmine, Rose Bottom: Musk\n\nSize: 13.5 oz Jar | 3.5 x 3.5 x 4\" 60+ Hours\n\nNatural Soy Wax, Essential and Premium Fragrance Oils, Cotton Wick, Reusable Jar. Phthalate Free, Non-Toxic, Cruelty Free, Vegan, Non-GMO.\n\n Hand Poured in Minnetonka, MN, Made in USA",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:11.898Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
